import DuplicateTemplate from './DuplicateTemplate'

export default DuplicateTemplate
